class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const isCartPage = document.querySelector("cart-items");

    if (isCartPage) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer-inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer-inner") ||
          this.querySelector(".drawer-close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("cart-drawer-quick-view");
   if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "hidden";
    document.body.style.padding = "0 4px 0 0";
   }

    const animatedElements = this.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      element.classList.add("aos-animate");
    });
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-drawer-quick-view");
    if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "scroll";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
    }

    const animatedElements = this.querySelectorAll(".aos-animate");
    animatedElements.forEach((element) => {
      element.classList.remove("aos-animate");
    });
  }

 /* setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer-inner").classList.contains("is-empty") &&
      this.querySelector(".drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }
*/

setSummaryAccessibility(cartDrawerNote) {
  cartDrawerNote.setAttribute("role", "button");

  // Point summary at its panel (if there is one)
  if (cartDrawerNote.nextElementSibling?.getAttribute("id")) {
    cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
  }

  // ✅ We are keeping it open, so default to expanded
  cartDrawerNote.setAttribute("aria-expanded", "true");

  const details = cartDrawerNote.closest("details");

  // If not inside a <details>, nothing else to do
  if (!details) {
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    return;
  }

  // ✅ Force open
  details.open = true;

  // ✅ Keep it open (bind once)
  if (!details.dataset.alwaysOpenBound) {
    details.dataset.alwaysOpenBound = "true";

    // If any script/user closes it, reopen immediately
    details.addEventListener("toggle", () => {
      if (!details.open) details.open = true;
      cartDrawerNote.setAttribute("aria-expanded", "true");
    });

    // Prevent click from closing (optional, but avoids flicker)
    cartDrawerNote.addEventListener("click", (e) => {
      e.preventDefault();
      details.open = true;
      cartDrawerNote.setAttribute("aria-expanded", "true");
    });
  }

  cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
}

renderContents(parsedState) {
  this.querySelector(".drawer-inner").classList.contains("is-empty") &&
    this.querySelector(".drawer-inner").classList.remove("is-empty");

  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  const forceDetailsCartDrawerOpen = () => {
    // ✅ Target the exact <details> you told me about
    const details = this.querySelector("#Details-CartDrawer") || document.querySelector("#Details-CartDrawer");
    if (!details) return false;

    details.open = true;

    const summary = details.querySelector("summary");
    if (summary) {
      summary.setAttribute("aria-expanded", "true");
      this.setSummaryAccessibility(summary);
    }

    // Extra guard in case other scripts close it later
    if (!details.dataset.alwaysOpenBound2) {
      details.dataset.alwaysOpenBound2 = "true";
      details.addEventListener("toggle", () => {
        if (!details.open) details.open = true;
      });
    }

    return true;
  };

  setTimeout(() => {
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    // Run now + a couple times after (some themes init accordions after render)
    forceDetailsCartDrawerOpen();
    setTimeout(forceDetailsCartDrawerOpen, 50);
    setTimeout(forceDetailsCartDrawerOpen, 150);

    this.open();
  });
}



/* End */
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer-inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
